module.exports = __webpack_public_path__ + "assets/img/list-6.93b74169.png";